import { render, staticRenderFns } from "./chemBaseRegul.vue?vue&type=template&id=52904184"
import script from "./chemBaseRegul.vue?vue&type=script&lang=js"
export * from "./chemBaseRegul.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52904184')) {
      api.createRecord('52904184', component.options)
    } else {
      api.reload('52904184', component.options)
    }
    module.hot.accept("./chemBaseRegul.vue?vue&type=template&id=52904184", function () {
      api.rerender('52904184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chem/chemBaseRegul.vue"
export default component.exports